import { api } from '../lib/axios';
import { AdInterface } from '../store/contexts/types/ad';
import { MakeOptional } from '../utils/make-optional';
import { DeleteStatus } from './types/AdServiceType';
import { StatsInterface } from './types/StatsServiceType';

export function getDeletingStatus(): Promise<DeleteStatus[]> {
  return api.get('motivo-exclusao', {
    params: {
      tipo: 'publicado'
    }
  });
}

export function deleteAd(aId: number, status: number): Promise<void> {
  return api.delete(`anuncio/${aId}`, {
    params: {
      'motivo-exclusao': status
    }
  });
}

export function sendFeedback(rating: string, feedback?: string): Promise<void> {
  return api.post(`pesquisa/nps`, {
    nota: rating,
    conteMais: feedback
  });
}

export function getCurrentAd(aId: number): Promise<AdInterface> {
  return api.get(`anuncio/${aId}`);
}

export function updateCurrentAd(aId: number, content: MakeOptional<AdInterface>): Promise<void> {
  return api.patch(`anuncio/${aId}`, {
    ...content
  });
}

export function renewAdById(id: number): Promise<void> {
  return api.put(`anuncio/${id}/reativar-anuncio`);
}

export function getPerformanceMetrics(id: number): Promise<StatsInterface> {
  return api.get(`anuncio/${id}/performance`);
}

export function getQualityTips(id: number): Promise<string[]> {
  return api.get(`anuncio/${id}/dicas-de-qualidade-para-anuncio`);
}
